import React from "react";
import "./Donate.css";

const Donate = () => {
  return (
    <div className="donate_parent_div">
      <h1>This is donate page</h1>
    </div>
  );
};

export default Donate;
